import { FormTemplate } from "components/modal/templates";
import { getInitialStateFromConfig } from "helpers/form";
import React from "react";
import { cancel } from "sources/books/distributionBids";

const config = {
    comment: {
        label: "Комментарий (необязательный)",
        textarea: true,
        inputProps: { name: "cancelComment" },
        fieldWrapper: "w-100",
        labelWrapper: "col-form-label col-form-label-sm pt-0",
    },
};

const initialState = getInitialStateFromConfig(config);

class DistributionBidCancellation extends FormTemplate {
    sendRequest = ({ id, cancelComment }) => cancel({ id, cancelComment }).then(() => this.close());

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return <input type="submit" className={cname} value="Отправить" />;
    };

    renderBodyInner = () => {
        const { comment } = config;
        return this.renderField(comment);
    };
}

const ConfiguredModal = (props) => {
    initialState.id = props.id;
    return <DistributionBidCancellation {...props} config={config} initialState={initialState} />;
};

export default ConfiguredModal;
